import { useEffect } from 'react';

import axios from 'axios';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge/es5'; // 使用es5版本，兼容低版本浏览器

import { env } from '@/utils/baseUrl';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// 全局缓存已加载的 SVG URL，避免重复加载
const loadedSprites = new Set();

export default function SvgIcon({ app = 'item', iconName, className, ...props }) {
  let staticBase = 'https://static.szlcsc.com';

  // 本地调试走代理
  if (env === 'local') {
    staticBase = '/static';
  }

  const spriteUrl = `${staticBase}/ecp/assets/apps/${app}/sprites/sprite.svg?version=${process.env.NEXT_PUBLIC_VERSION}`;

  useEffect(() => {
    if (loadedSprites.has(spriteUrl)) return;

    const loadSprite = async () => {
      try {
        loadedSprites.add(spriteUrl);
        const response = await axios.get(spriteUrl, {
          responseType: 'text',
          timeout: 10000,
        });
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(response.data, 'image/svg+xml');
        const svgElement = svgDoc.documentElement;
        // 隐藏元素
        svgElement.style.cssText = `
          position: absolute;
          width: 0;
          height: 0;
        `;
        document.body.prepend(svgElement);
      } catch (error) {
        console.error('Failed to load SVG:', error);
      }
    };

    loadSprite();
  }, [spriteUrl]);

  return (
    <svg
      className={cn('h-6 w-6', className)}
      fill="currentColor" // 继承父级颜色
      {...props}
    >
      <use href={`#icon-${app}-${iconName}`} />
    </svg>
  );
}
